import {
  CheckCircle as AcceptIcon,
  Cancel as DeclineIcon,
} from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Button, Stack, Typography } from '@mui/material';
import type { FC } from 'react';

interface Props {
  busy: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

export const AssignmentResponseAlert: FC<Props> = ({
  busy,
  onAccept,
  onDecline,
}) => (
  <Alert severity="warning">
    <Stack
      alignItems={{ sm: 'center' }}
      direction={{ sm: 'row', xs: 'column' }}
      gap={2}
      justifyContent="space-between"
    >
      <Typography>
        You have not responded to this patrol assignment. Please accept or
        decline it.
      </Typography>
      <Stack direction="row" flexShrink={0} gap={1}>
        <Button
          color="error"
          disabled={busy}
          onClick={onDecline}
          startIcon={<DeclineIcon />}
          variant="outlined"
        >
          Decline
        </Button>
        <LoadingButton
          color="success"
          loading={busy}
          onClick={onAccept}
          startIcon={<AcceptIcon />}
          variant="contained"
        >
          Accept
        </LoadingButton>
      </Stack>
    </Stack>
  </Alert>
);
